// import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import * as RoutePath from '../pages/index';
// import Error from '../error/error';
// import TopNav from '../layout/topNavBar';
// import Middleware from '../middleware/middleware';
import RoutesDef from './routeDef';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from '@azure/msal-react';
import { loginRequest } from '../auth/authconfig';
import { useEffect } from 'react';
import { setMsalTokenHandler } from '../plugins/axios';

const AuthContent = () => {
  const { instance, accounts, inProgress } = useMsal();
  
  useEffect(() => {
    // Set up the token handler for axios interceptor
    // This retrieves tokens from MSAL's secure cache
    const msalTokenHandler = async () => {
      if (accounts && accounts.length > 0) {
        try {
          const resp = await instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
          });
          return resp.accessToken;
        } catch (error) {
          console.error('[Auth] Error acquiring token:', error);
          // If interactive login is required, throw to let the interceptor handle it
          throw error;
        }
      }
      return null;
    };
    
    setMsalTokenHandler(msalTokenHandler);
  }, [instance, accounts]);
  
  useEffect(() => {
    const ensureToken = async () => {
      // MSAL v3 handles token caching internally through BrowserCacheManager
      // Do not manually store tokens in sessionStorage as this is a security risk.
      // Instead, rely on MSAL's secure caching mechanism.
      
      if (accounts && accounts.length > 0) {
        try {
          // Attempt silent token acquisition; MSAL will use cached token if available
          await instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
          });
          // Token is cached by MSAL internally; use it for authenticated requests
          // Axios interceptor will retrieve token from MSAL cache when needed
        } catch (error) {
          console.error('[Auth] Error acquiring token:', error);
          // If silent token acquisition fails, trigger interactive login
          if (error.errorCode === 'consent_required' || 
              error.errorCode === 'interaction_required' ||
              error.errorCode === 'login_required') {
            instance.acquireTokenRedirect(loginRequest);
          }
        }
      }
    };
    
    // Only run if MSAL is not in startup/login phase
    if (inProgress === 'none') {
      ensureToken();
    }
  }, [instance, accounts, inProgress]);
  
  // Always render routes - let middleware handle token checking
  return <RoutesDef />;
};

const AuthUser = () => {
  const { instance } = useMsal();
  instance.loginRedirect(loginRequest).catch((e) => {});
};

const MainContent = () => {
  return (
    <>
      <AuthenticatedTemplate>
        <AuthContent />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <AuthUser />
      </UnauthenticatedTemplate>
    </>
  );
};

export default function Routing() {
  return <MainContent />;
}
